export const fieldsItems = [
    { value: "customer_name", label: "Cliente" },
    {
        value: "holder_name",
        label: "Nome do Titular",
    },
    {
        value: "status_id",
        label: "Status",
    },
];

export const periodsItems = [
    {
        value: 30,
        label: "1 Mês",
    },
    {
        value: 90,
        label: "3 Meses",
    },
    {
        value: 180,
        label: "6 Meses",
    },
    {
        value: 365,
        label: "1 Ano",
    },
    {
        value: 1095,
        label: "3 Anos",
    },
    {
        value: 1825,
        label: "5 Anos",
    },
    {
        value: 20000,
        label: "Todo o período",
    },
];

export const mbStatus = [
    {
        value: 0,
        label: "Todos",
    },
    {
        value: 1,
        label: "Abertas",
    },
    {
        value: 2,
        label: "Fechadas",
    },
    {
        value: 3,
        label: "Atrasadas",
    },
    {
        value: 4,
        label: "Pagas",
    },
    {
        value: 5,
        label: "Sem Pendências",
    },
    {
        value: 6,
        label: "Canceladas",
    },
    {
        value: 7,
        label: "Inativas",
    },
    {
        value: 8,
        label: "Processando",
    },
];

export function getDateToFormat(subDays: number) {
    const d = new Date();
    d.setDate(d.getDate() - subDays);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

export const datesInitials = `${new Date().getFullYear()}-${String(
    new Date().getMonth() + 1
).padStart(2, "0")}-01`;

export const datesEndInitials = getDateToFormat(0);

export const defaultFilter = {
    filterType: "customer_name",
    filterValue: "",
    status: 4,
    startDate: datesInitials,
    endDate: datesEndInitials,
    monthlybilling: null,
    period: 30,
};
